import { useEffect } from 'react';
import { log } from 'log';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useUserSelector } from 'js/store/hooks';

import * as actions from '../store/actions';
import { TOAST_MESSAGE_PREFS_TAG_NAME } from '../constants';
import { useGetPlayerTags } from 'server';

export const useGetToastTimeoutValue = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const getPlayerTags = useGetPlayerTags();

    useEffect((): void => {
        (async (): Promise<void> => {
            try {
                if (!isLoggedIn) {
                    return;
                }

                const { tags: [tag] = [] } = await getPlayerTags({ tagName: TOAST_MESSAGE_PREFS_TAG_NAME });
                const toastTimeoutValue = Number(tag?.value);

                toastTimeoutValue && dispatch(actions.userSetAttributesAction({ toastTimeoutValue }));
            } catch (error) {
                log('error', error);
            }
        })();
    }, [dispatch, getPlayerTags, isLoggedIn]);
};
